// extracted by mini-css-extract-plugin
module.exports = {"content":"BrokerDashboard_content__vAvJQ"};